import { type SlotEntry } from 'customer-flows/components/_config/registry'

export const heros: SlotEntry[] = [
  {
    type: 'hero',
    name: 'activity-summary',
    componentPath: 'activity-summary',
    variant: 'DEFAULT',
    supportedPages: ['FlowConfigBookingStartPage', 'FlowConfigBookingExtensionPage']
  },
  {
    type: 'hero',
    name: 'payment-summary',
    componentPath: 'payment-summary',
    variant: 'DEFAULT',
    supportedPages: ['FlowConfigBookingPaymentPage', 'FlowConfigBookingExtensionPage']
  },
  {
    type: 'hero',
    name: 'cart-summary',
    componentPath: 'cart-summary',
    variant: 'DEFAULT',
    supportedPages: ['FlowConfigBookingUpsellsPage', 'FlowConfigBookingInfoPage', 'FlowConfigBookingExtensionPage']
  }
]
